import { useCallback } from 'react'
import { useSidepanelLocked, useSetSidepanelLocked } from '../../atoms'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { ChromePinButton } from './chrome-pin-button'

/** Locked keeps the panel open (prevents backdrop click-to-close). */
export function SidepanelLockButton() {
  const locked = useSidepanelLocked()
  const setLocked = useSetSidepanelLocked()

  const handleToggleLock = useCallback(() => {
    AmplitudeRenderer.trackEvent('Sidepanel Header', { action: locked ? 'unlock panel' : 'lock panel' })
    setLocked(!locked)
  }, [locked, setLocked])

  return <ChromePinButton pressed={locked} tooltip={locked ? 'Allow close' : 'Keep open'} onClick={handleToggleLock} />
}
